
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { GetAllFinacUserPayloadType } from '../../../commonTypes/authTypes';
import { UpdateIdPasswordManagerPayloadType } from '../../../commonTypes/stcoToolsType';
import { CommonHeader, ContentArea, ErrorSuccessModal } from '../../../components/commons';
import AddEditClientIdPasswordManagerForm from '../../../components/StcoTools/ClientIdPasswordManager/AddEditClientIdPasswordManagerForm';
import useDebounce from '../../../customHooks/useDebounce';
import {  getAllFinacClientUsersAction, getAllFinacUsersAction, resetFinacUsersList, resetSession } from '../../../redux/auth';
import { LoginResponseType } from '../../../redux/auth/authTypes';
import { RootState } from '../../../redux/rootReducers';
import { editClientIdPasswordManagerAction, resetIdPasswordManagerError, resetIdPasswordManagerStatusCode, resetIdPasswordManagerSuccess } from '../../../redux/stcoTools';

type AppProps = {
  history: any;
  loginData: LoginResponseType;
  fetching: boolean;
  userFetching: boolean;
  token: string | null;
  error: string | null;
  success: number | null;
  statusCode: number | null;
  totalUserCount: number | string | any
  dispatchResetSession: () => void;
  dispatchResetIdPasswordManagerError: () => void;
  dispatchResetIdPasswordManagerSuccess: () => void;
  dispatchResetIdPasswordManagerStatusCode: () => void;
  dispatchResetFinacUsersList: () => void;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchGetAllFinacClientUsersAction: (data: GetAllFinacUserPayloadType) => void;
  finacUsersList: any;
  finacClientUsersList: any;
  dispatchEditClientIdPasswordManagerAction: (data: UpdateIdPasswordManagerPayloadType) => void;
}

const EditClientIdPasswordManager = ({
  history,
  token,
  loginData,
  success,
  statusCode,
  fetching,
  userFetching,
  error,
  totalUserCount,
  dispatchGetAllFinacUsersAction,
  finacUsersList,
  dispatchResetSession,
  dispatchEditClientIdPasswordManagerAction,
  dispatchResetIdPasswordManagerError,
  dispatchResetIdPasswordManagerSuccess,
  dispatchGetAllFinacClientUsersAction,
  finacClientUsersList,
  dispatchResetIdPasswordManagerStatusCode,
  dispatchResetFinacUsersList
}: AppProps) => {
  const editData = history?.location?.state?.data;
  const company_name = history?.location?.state?.company_name;
  const client_code = history?.location?.state?.client_code;
  const [offset, setoffset] = useState(0);
  const [text, setText] = useState("");
  const [limit, setLimit] = useState(20);
  const [finacApiCall,setFinacApiCall]=useState(false)
  const userSelected= history?.location?.state?.userSelected
  const selectCategory= history?.location?.state?.selectCategory
  const searchData = history?.location?.state?.searchData

  useEffect(() => {
    dispatchResetIdPasswordManagerError();
    dispatchResetIdPasswordManagerSuccess();
    dispatchResetIdPasswordManagerStatusCode();
    dispatchResetFinacUsersList();
    if (token) {
      const finalData = {
        token,
        client_code,
        user_type:'client_users',
        status:1,
      }
      dispatchGetAllFinacClientUsersAction(finalData)
    }
    //eslint-disable-next-line
  }, [])
  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset,
        limit,
        user_type: 'stco_users',
        status: 1,
        client_code,
        search_term: text,
      };
      if (offset <= finacUsersList?.total_count&&finacApiCall) {

        dispatchGetAllFinacUsersAction(finalUserData)
      }
    }
    //eslint-disable-next-line
  }, [offset])

  const handleSubmitEditClientIdPasswordForm = (data: any) => {
    const finalData = {
      ...data,
    }
    dispatchEditClientIdPasswordManagerAction(finalData)
  }

  const fetchNewData = (search: string) => {
    const finalData = {
      token,
      offset,
      limit,
      user_type: 'stco_users',
      status: 1,
      client_code,
      search_term: text,
    }
    dispatchGetAllFinacUsersAction(finalData)
  }

  // Custom debounce hook for search data
  useDebounce(() => {
    if(text){
      fetchNewData(text)
      }
      else{
        setFinacApiCall(true)
       const finalData = {
         token,
         offset,
          limit,
          user_type:'stco_users',
          status:1,
         search_term: text,
       }
       dispatchGetAllFinacUsersAction(finalData)
      }
  }, 500, [text]);

  const handleGoBack=()=>{
    history.push({
      pathname:`/client-id-password-manager/${client_code}`,
      state:{client_code,company_name,userSelected,selectCategory,searchData}
    });
  }

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetIdPasswordManagerError();
            }}
          />
        );
      }
    }

    if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={`Id Password Updated Successfully!`}
          buttonText="OK"
          onPress={() => {
            dispatchResetIdPasswordManagerSuccess();
            handleGoBack()
          }}
          statusCode={statusCode}
        />
      )
    }

    return false;
  };

  return (
    <>
      <CommonHeader title='Edit Id/Password' company_name={company_name} client_code={client_code} />
      <ContentArea>
        <AddEditClientIdPasswordManagerForm
          history={history}
          client_code={client_code}
          company_name={company_name}
          fetching={fetching}
          userFetching={userFetching}
          totalUserCount={totalUserCount}
          loginData={loginData}
          editData={editData}
          finacUsersList={finacUsersList?.data}
          finacClientUsersList={finacClientUsersList?.data}
          token={token}
          handleSubmitEditClientIdPasswordForm={handleSubmitEditClientIdPasswordForm}
          setoffset={setoffset}
          setText={setText}
          setLimit={setLimit}
          limit={limit}
          offset={offset}
          handleGoBack={handleGoBack}
        />
      </ContentArea>
      {handleErrorModal()}
    </>
  )
}

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  finacUsersList: state.auth.finacUsersList,
  finacClientUsersList: state.auth.finacClientUsersList,
  success: state.stcoTools.success,
  error: state.stcoTools.error,
  statusCode: state.stcoTools.statusCode,
  loginData: state.auth.loginData,
  fetching: state.stcoTools.fetching,
  totalUserCount: state.auth.totalUserCount,
  userFetching: state.auth.fetching,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetIdPasswordManagerSuccess: () => dispatch(resetIdPasswordManagerSuccess()),
  dispatchResetIdPasswordManagerError: () => dispatch(resetIdPasswordManagerError()),
  dispatchResetIdPasswordManagerStatusCode: () => dispatch(resetIdPasswordManagerStatusCode()),
  dispatchResetFinacUsersList: () => dispatch(resetFinacUsersList()),
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => dispatch(getAllFinacUsersAction(data)),
  dispatchGetAllFinacClientUsersAction: (data:GetAllFinacUserPayloadType) => dispatch(getAllFinacClientUsersAction(data)),
  dispatchEditClientIdPasswordManagerAction: (data: UpdateIdPasswordManagerPayloadType) => dispatch(editClientIdPasswordManagerAction(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(EditClientIdPasswordManager);